export const rucTDE = '1792073634001';
export const passportDigits = 10;
export const solNacDigits = 5;

